export default __webpack_public_path__ + "static/media/BinarySearchTree.0ea5af15.jpg";